// Mirrors api/orm/models/shared/carbonProgramDraft.ts and api/consts/carbonProgramDrafts.ts — keep them in sync

export const CARBON_PROGRAM_DRAFT_KIND = {
  create: "create",
  update: "update",
} as const;

export type CarbonProgramDraftKind = (typeof CARBON_PROGRAM_DRAFT_KIND)[keyof typeof CARBON_PROGRAM_DRAFT_KIND];

export const CARBON_PROGRAM_DRAFT_STATUS = {
  draft: "draft",
  submitted: "submitted",
  approved: "approved",
  rejected: "rejected",
  implemented: "implemented",
} as const;

export type CarbonProgramDraftStatus = (typeof CARBON_PROGRAM_DRAFT_STATUS)[keyof typeof CARBON_PROGRAM_DRAFT_STATUS];

export const CARBON_PROGRAM_DRAFT_EDITABLE_STATUSES: CarbonProgramDraftStatus[] = [CARBON_PROGRAM_DRAFT_STATUS.draft, CARBON_PROGRAM_DRAFT_STATUS.rejected];

// The proposed CarbonProgram; may be incomplete until the draft is submitted
export type CarbonProgramDraftConfig = Record<string, unknown>;

export interface CarbonProgramDraftIssue {
  severity: "error" | "warning";
  // dot path into the config, empty for issues about the whole draft
  path: string;
  message: string;
}

export interface CarbonProgramDraftAdminUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
}

export interface CarbonProgramDraftSummary {
  id: string;
  kind: CarbonProgramDraftKind;
  programId: string;
  status: CarbonProgramDraftStatus;
  config: CarbonProgramDraftConfig;
  notes: string | null;
  signedContractKey: string | null;
  createdById: string;
  submittedAt: string | null;
  reviewedById: string | null;
  reviewedAt: string | null;
  reviewComment: string | null;
  implementedById: string | null;
  implementedAt: string | null;
  createdAt: string;
  updatedAt: string;
  createdBy: CarbonProgramDraftAdminUser | null;
  reviewedBy: CarbonProgramDraftAdminUser | null;
  implementedBy: CarbonProgramDraftAdminUser | null;
}

export interface CarbonProgramDraftDetails extends CarbonProgramDraftSummary {
  // errors block submit and approval; warnings are for the reviewer
  issues: CarbonProgramDraftIssue[];
  signedContractUrl: string | null;
}

export interface CreateCarbonProgramDraftRequest {
  kind: CarbonProgramDraftKind;
  programId?: string;
  config?: CarbonProgramDraftConfig;
  notes?: string | null;
}

export interface UpdateCarbonProgramDraftRequest {
  id: string;
  config?: CarbonProgramDraftConfig;
  notes?: string | null;
}

export interface ReviewCarbonProgramDraftRequest {
  id: string;
  decision: "approve" | "reject";
  comment?: string;
}
